// UTILS
import {onlyDigits} from "commons/js/RegExp";

/**
 * It handles keyboard events by preventing alpha keys.
 *
 * @param {KeyboardEvent} event The keyboard event.
 * @returns {void}
 */
function preventAlphaChars(event) {
  const { key } = event;

  if (!onlyDigits().test(key)) {
    event.preventDefault();
  }
}

export {
  preventAlphaChars
};
